import { comparePrimarySortPropertyThenStatus } from "../../utils";
export const initFilter = {
    id: "ALL",
    severity: "ALL",
    effort: "ALL",
};
export const initSort = { property: "grade", reverse: true };
export const specialCasesForSorting = {
    severity: (first, second, reverse) => comparePrimarySortPropertyThenStatus({ primarySortProperty: first.severity, status: first.status }, { primarySortProperty: second.severity, status: second.status }, reverse),
    effort: (first, second, reverse) => comparePrimarySortPropertyThenStatus({ primarySortProperty: first.effort, status: first.status }, { primarySortProperty: second.effort, status: second.status }, reverse),
    grade: (first, second, reverse) => comparePrimarySortPropertyThenStatus({ primarySortProperty: first.grade, status: first.status }, { primarySortProperty: second.grade, status: second.status }, reverse),
};
export function filterPolicies(policy, filter) {
    const id = filter.id === "ALL" ? true : policy.id.startsWith(filter.id);
    const severity = filter.severity === "ALL"
        ? true
        : policy.severity.toLowerCase() === filter.severity;
    const effort = filter.effort === "ALL"
        ? true
        : policy.effort.toLowerCase() === filter.effort;
    return id && severity && effort;
}
export function updatePolicyCategory(categories, policyID) {
    if (policyID.startsWith("SQ"))
        categories["SQ"] = "Software quality";
    else if (policyID.startsWith("DQ"))
        categories["DQ"] = "Suggestions";
    else if (policyID.startsWith("TH"))
        categories["TH"] = "Threat hunting";
    else if (policyID.startsWith("YR"))
        categories["YR"] = "YARA policies";
}
//# sourceMappingURL=utils.js.map